module.exports = __webpack_public_path__ + "static/media/9.338ad235.jpg";